// Masks a phone number for display in the verify-account popup, keeping the
// leading country/operator digits and the last two so the user can recognise
// their own number, e.g. "+966 58 395 5970" -> "96658*****70".
// Non-digits are stripped; numbers too short to mask meaningfully are returned
// as their plain digits.
export const maskPhone = (phone) => {
	const digits = String(phone ?? '').replace(/\D/g, '');
	if (digits.length <= 7) return digits;
	const head = digits.slice(0, 5);
	const tail = digits.slice(-2);
	const stars = '*'.repeat(digits.length - 7);
	return `${head}${stars}${tail}`;
};
